export default __webpack_public_path__ + "static/media/user-1.e71b1c4e.png";